import Parcela from "@/Models/Parcela";

const state = () => ({
  matriculaSelecionada: null,
  parcelaSelecionada: null,
  parcelas: null,
  parcelasSelecionadas: [],
  formaPagamento: null,
});

const mutations = {
  setMatriculaSelecionada(state, matricula) {
    state.matriculaSelecionada = matricula;
  },
  setParcelaSelecionada(state, parcela) {
    state.parcelaSelecionada = parcela;
  },
  setParcelasSelecionadas(state, parcelas) {
    state.parcelasSelecionadas = parcelas;
  },
  setFormaPagamento(state, forma) {
    state.formaPagamento = forma;
  },
};

const actions = {};
const getters = {
  matriculaSelecionada: (state) => state.matriculaSelecionada,
  parcelaSelecionada: (state) =>
    state.parcelaSelecionada ? new Parcela(state.parcelaSelecionada) : null,
  parcelas: (state) => (state.matriculaSelecionada ? state.matriculaSelecionada.parcelas : null),
  parcelasSelecionadas: (state) => state.parcelasSelecionadas.map((p) => new Parcela(p)),
  formaPagamento: (state) => state.formaPagamento,
};
const namespaced = true;
export default {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};
